import React from 'react';

function BooleanCell(props) {
  const { cell } = props;
  return <div>{cell?.value ? 'True' : 'False'}</div>;
}

export default BooleanCell;
